<template>
  <p>
    <i18n-t keypath="Il dominio {0} risulta: ">
      <strong>{{ wizard.nomeDominio }}</strong>
    </i18n-t>
    <span v-if="wizard.availableDomain"
      ><strong class="pf-v6-u-text-color-status-success">{{ $t('Disponibile') }}</strong
      >. {{ $t('Ci occuperemo noi delle pratiche di registrazione.') }}</span
    >
    <span v-else
      ><strong class="pf-v6-u-text-color-status-warning">{{ $t('Già registrato') }}</strong
      >. {{ $t('Ci occorrerà solo il codice auth-code e poi ci occuperemo noi di tutte le pratiche di trasferimento.') }}</span
    >
  </p>
</template>

<script lang="ts" setup>
import { useWizard } from '@/wizard';
const wizard = useWizard();
</script>
